import { Component } from '@angular/core';

@Component({
  selector: 'nw-lab',
  templateUrl: './lab.component.html',
  styleUrls: ['./lab.component.scss'],
})
export class LabComponent {}
